
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/p2p",
      function () {
        return require("private-next-pages/p2p/index.instantwire.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/p2p"])
      });
    }
  